// === COMBO BOXES FUNCTIONALITY ===

/**
 * Initializes all combo box dropdown interactions
 */
function initializeComboBoxes() {
  document.querySelectorAll('select').forEach(select => {
    select.addEventListener('change', function(event) {
      event.stopPropagation();
    }, true);
  });
  
  const toggleButtons = document.querySelectorAll('[is="toggle-button"]');

  toggleButtons.forEach(button => {
    const comboBoxId = button.getAttribute('aria-controls');
    const comboBox = document.getElementById(comboBoxId);
    if (!comboBox) return;

    const selectedValueDisplay = button.querySelector('.select__selected-value');
    const hiddenSelect = comboBox.querySelector('select');
    const optionItems = comboBox.querySelectorAll('.combo-box__option-item');

    button.addEventListener('click', function(e) {
      const isExpanded = button.getAttribute('aria-expanded') === 'true';

      document.querySelectorAll('.combo-box[open]').forEach(box => {
        if (box.id !== comboBoxId) {
          box.removeAttribute('open');
          const otherButton = document.querySelector(`[aria-controls="${box.id}"]`);
          if (otherButton) otherButton.setAttribute('aria-expanded', 'false');
        }
      });

      button.setAttribute('aria-expanded', !isExpanded);
      if (!isExpanded) {
        comboBox.setAttribute('open', '');
        const selectedOption = comboBox.querySelector('[aria-selected="true"]');
        if (selectedOption) selectedOption.focus();
      } else {
        comboBox.removeAttribute('open');
      }
    });

    optionItems.forEach(option => {
      option.addEventListener('click', function(event) {
        event.stopPropagation();
        event.preventDefault();

        if (option.hasAttribute('disabled')) return;

        optionItems.forEach(item => item.setAttribute('aria-selected', 'false'));
        option.setAttribute('aria-selected', 'true');

        if (selectedValueDisplay) {
          selectedValueDisplay.innerHTML = option.innerHTML;
        }

        if (hiddenSelect) {
          hiddenSelect.value = option.getAttribute('value');
          const changeEvent = new Event('change', { bubbles: false });
          hiddenSelect.dispatchEvent(changeEvent);
        }

        comboBox.removeAttribute('open');
        button.setAttribute('aria-expanded', 'false');
        
        // Update master select when an option is selected
        const selectorItem = getChangedSelectorItem(option);
        if (selectorItem) {
          updateMasterSelect(selectorItem);
        }
      });
    });

    const closeButton = comboBox.querySelector('[data-action="close"]');
    if (closeButton) {
      closeButton.addEventListener('click', function(event) {
        event.stopPropagation();
        comboBox.removeAttribute('open');
        button.setAttribute('aria-expanded', 'false');
      });
    }
  });

  document.addEventListener('click', function(event) {
    if (!event.target.closest('.select-wrapper') && !event.target.closest('.combo-box')) {
      document.querySelectorAll('.combo-box[open]').forEach(box => {
        box.removeAttribute('open');
        const button = document.querySelector(`[aria-controls="${box.id}"]`);
        if (button) button.setAttribute('aria-expanded', 'false');
      });
    }
  });

  document.querySelectorAll('.combo-box').forEach(comboBox => {
    const selectedOption = comboBox.querySelector('[aria-selected="true"]');
    const button = document.querySelector(`[aria-controls="${comboBox.id}"]`);
    const selectedValueDisplay = button?.querySelector('.select__selected-value');
    if (selectedOption && selectedValueDisplay) {
      selectedValueDisplay.innerHTML = selectedOption.innerHTML;
    }
  });
}

/**
 * Gets the parent selector item for a changed element
 */
function getChangedSelectorItem(element) {
  return element.closest(".quantity-break__selector-item");
}

/**
 * Updates the master variant select based on the current selections
 */
function updateMasterSelect(changedSelector) {
  const masterSelect = document.getElementById("master-select");
  
  if (!changedSelector || !masterSelect) {
    return;
  }

  const selectedOptions = changedSelector.querySelectorAll(".combo-box__option-item[aria-selected='true']");
  const selectedValues = Array.from(selectedOptions).map(option => option.getAttribute("value"));

  const matchingOption = Array.from(masterSelect.options).find(option =>
    selectedValues.every(val => option.textContent.includes(val))
  );

  if (!matchingOption) {
    return;
  }

  masterSelect.value = matchingOption.value;
  const selectedMediaId = matchingOption.getAttribute("data-media-id");
  if (selectedMediaId) {
    scrollToMedia(selectedMediaId);
  }
}

/**
 * Scrolls to the media item with the given ID
 */
function scrollToMedia(mediaId) {
  const mediaElements = Array.from(document.querySelectorAll(".swiper-product .swiper-wrapper > li[data-media-id]") || []);
  
  const targetIndex = mediaElements.findIndex(li => {
    const fullId = li.getAttribute("data-media-id") || "";
    const lastDash = fullId.lastIndexOf("-");
    const extractedId = lastDash !== -1 ? fullId.substring(lastDash + 1) : fullId;
    return extractedId === mediaId;
  });

  if (targetIndex !== -1) {
    if (typeof sliderImages !== "undefined" && sliderImages.slideTo) {
      sliderImages.slideTo(targetIndex);
    } else {
      mediaElements[targetIndex].scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  }
}

// Auto-initialize if DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeComboBoxes);
} else {
  initializeComboBoxes();
}